function handleAccordionUrlHash() {
  if (!window.location.hash) {
    return
  }

  const accordionItems = document.querySelectorAll('.accordion-item')
  if (!accordionItems.length) {
    return
  }

  const targetElement = document.getElementById(window.location.hash.slice(1))
  if (!targetElement) {
    return
  }

  if (targetElement) {
    const containerItem = targetElement.closest('.accordion-item')
    const containerButton = containerItem.querySelector('.accordion-heading')
    containerButton.click()
    targetElement.scrollIntoView({ behavior: 'smooth' })
  }
}

document.addEventListener('DOMContentLoaded', handleAccordionUrlHash)
